module.exports = __webpack_public_path__ + "static/phone-call-bf427a0eb10cc96f75770ba97e3da71b.png";